import { render, staticRenderFns } from "./MerchantAuth.vue?vue&type=template&id=123bd52e&scoped=true"
import script from "./MerchantAuth.vue?vue&type=script&lang=js"
export * from "./MerchantAuth.vue?vue&type=script&lang=js"
import style0 from "./MerchantAuth.vue?vue&type=style&index=0&id=123bd52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123bd52e",
  null
  
)

export default component.exports